module.exports = __webpack_public_path__ + "static/media/ic-like-filled.703c5c35.svg";